import React, { useState, useEffect, act } from "react";
import axios from 'axios';
import Recojo from "./recojo/Recojo";
import Entrega from "./entrega/Entrega";
import Options from "./options/Options";
import MyAccount from "./account/MyAccount";
import MapSelection from "./recojo/MapSelection";
import PrintDeliveries from "./analytics/PrintDeliveries";
import Inventory from "./inventory/Inventory";
import StoreCommunicationInbox from "../shared/communication/StoreCommunicationInbox";
import SupportCommunicationInbox from "../shared/communication/SupportCommunicationInbox";
import ControlTower from "./controltower/ControlTower";
import Analytics from "./analytics/Analytics";
import ProviderCatalog from "./catalog/ProviderCatalog";
import EntregaProvincia from "./entrega/EntregaProvincia";
import ReferralDashboard from "./referral/ReferralDashboard";
import MasivoWizard from "./masivo/MasivoWizard";
import ExpressDeliveryPage from './express/ExpressDeliveryPage';
import Integrations from "../shared/integrations/Integrations";


function MainUser({ user_id, username, onLogout, email, phone_number, onUpdateUser }) {    
    const [activeComponent, setActiveComponent] = useState('Options');
    const [addresses, setAddresses] = useState([]);
    
    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const token = localStorage.getItem('token'); // Fetch token from local storage (if using token-based auth)
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user_addresses/${user_id}`, {
                    headers: {
                        Authorization: `Bearer ${token}` // Include authorization header if necessary
                    }
                });
                
                if (response.data.addresses.length === 0) {
                    // If no addresses are found, navigate to 'MapSelection'
                    setActiveComponent('MapSelection');
                } else {
                    // If addresses are found, update the state
                    setAddresses(response.data.addresses);
                }
            } catch (error) {
                console.error('Error fetching user addresses:', error);
            }
        };
    
        // Call the API only if addresses are empty
        if (addresses && addresses.length === 0) {
            fetchAddresses(); // Fetch addresses from the API
        }
    }, [addresses, user_id]); // Add user_id as a dependency
   
    return (
        <div className="container-fluid p-0">

            {activeComponent === 'Recojo' && <Recojo setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Entrega' && <Entrega userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'EntregaExpress' && <ExpressDeliveryPage userId={user_id} setActiveComponent={setActiveComponent} />}
            {activeComponent === 'EntregaProvincia' && <EntregaProvincia userId={user_id} setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'ControlTower' && <ControlTower userId={user_id} setActiveComponent={setActiveComponent} /> }
            {activeComponent === 'Inventory' && <Inventory userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Analytics' && <Analytics userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'ProviderCatalog' && <ProviderCatalog userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Options' && <Options username={username}  setActiveComponent={setActiveComponent} onLogout={onLogout}/>}
            {activeComponent === 'MyAccount' && <MyAccount onUpdateUser={onUpdateUser} userId={user_id} username={username} phoneNumber={phone_number} email={email} onLogout={onLogout} setActiveComponent={setActiveComponent} />}
            {activeComponent === 'MapSelection' && <MapSelection setActiveComponent={setActiveComponent} userId={user_id} />}
            {activeComponent === 'Print' && <PrintDeliveries userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Chat' && <StoreCommunicationInbox userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'SupportChat' && <SupportCommunicationInbox userId={user_id} setActiveComponent={setActiveComponent} scope="store" backTarget="Options"/>}
            {activeComponent === 'Referrers' && <ReferralDashboard userId={user_id} setActiveComponent={setActiveComponent} returnComponent="MyAccount" />}
            {activeComponent === 'MasivoWizard' && <MasivoWizard userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Integrations' && <Integrations userId={user_id} setActiveComponent={setActiveComponent} returnComponent="Options" />}
        </div>
    );
}

export default MainUser;
